import styled from 'styled-components'

export const ContentStyled = styled.div`
  padding: 10px;
`
